import { AbstractControl, ValidatorFn } from '@angular/forms';

export interface AbstractControlWarn extends AbstractControl {
  warnings: unknown;
}

interface BudgetRow {
  rowId: string;
  columnId?: string;
  value: string;
}
export function BudgetNoBudgetForKostnadslag(
  budgets: { id: string; budget: number }[],
) {
  return (control: AbstractControlWarn): ValidatorFn => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);
      const warnings: Record<string, boolean> = {};

      for (const budget of budgets) {
        if (budget.budget === 0) {
          const rowsForBudget = parsedValue.filter(
            (b: BudgetRow) => b.rowId === budget.id,
          );
          const hasNonZero = rowsForBudget.some(
            (b: BudgetRow) => Number(b.value) !== 0,
          );
          if (hasNonZero) {
            warnings[`BudgetNoBudgetForKostnadslag_${budget.id}`] = true;
          }
        }
      }

      if (Object.keys(warnings).length > 0) {
        control.warnings = warnings;
      }
    }
    return undefined;
  };
}
